'use strict';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustRowTopPositionToViewport = exports.findAncestorWithClassName = exports.getMaxOverlappingItems = exports.getNearestRowNumber = exports.getTrueBottom = exports.getVerticalMarginBorder = exports.getRowObjectRowNumber = exports.getNearestRowObject = exports.rowLayerRenderer = exports.rowItemsRenderer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var types_1 = require("../types");
/**
 * Render all items in a row
 * @external {moment} http://momentjs.com/
 * @param  {Item[]} items List of items to render for this row
 * @param  {moment} vis_start The visible start of the timeline
 * @param  {moment} vis_end The visible end of the timeline
 * @param  {number} total_width pixel width of the timeline
 * @param  {number} itemHeight The height of the item in px
 * @param  {function} itemRenderer The renderer of the item
 * @param  {Object[]} selectedItems
 * @param  {Object} itemRendererDefaultProps
 * @param  {function} getStartFromItem Function that returns the start of an item
 * @param  {function} getEndFromItem Function that returns the end of an item
 */
function rowItemsRenderer(items, vis_start, vis_end, total_width, itemHeight, itemRenderer, selectedItems, itemRendererDefaultProps, getStartFromItem, getEndFromItem, timelineTestids, displayItemOnSeparateRowIfOverlap, verticalGapBetweenOverlappingItems, rowTopBottomPadding, zIndexFunction, rowIndex) {
    if (selectedItems === void 0) { selectedItems = []; }
    var start_end_ms = vis_end.diff(vis_start, 'milliseconds');
    var pixels_per_ms = total_width / start_end_ms;
    var filtered_items = lodash_1.default.filter(items, function (i) {
        // if end not before window && start not after window
        return !getEndFromItem(i).isBefore(vis_start) && !getStartFromItem(i).isAfter(vis_end);
    });
    var displayItems = [];
    positionItemsOnRowAndGetRowHeight(filtered_items, rowIndex, displayItemOnSeparateRowIfOverlap, getStartFromItem, getEndFromItem, function (item, rowOffset) {
        item = lodash_1.default.clone(item);
        item.rowOffset = rowOffset;
        displayItems.push(item);
    });
    return lodash_1.default.map(displayItems, function (i) {
        var Comp = itemRenderer;
        var displayCurrentItemOnSeparateRow = typeof displayItemOnSeparateRowIfOverlap === "function"
            ? displayItemOnSeparateRowIfOverlap(i, rowIndex)
            : displayItemOnSeparateRowIfOverlap;
        var top = displayCurrentItemOnSeparateRow
            ? rowTopBottomPadding + i['rowOffset'] * (itemHeight + verticalGapBetweenOverlappingItems)
            : rowTopBottomPadding;
        var item_offset_mins = getStartFromItem(i).diff(vis_start, 'milliseconds');
        var item_duration_mins = getEndFromItem(i).diff(getStartFromItem(i), 'milliseconds');
        var left = Math.round(item_offset_mins * pixels_per_ms);
        var width = Math.round(item_duration_mins * pixels_per_ms);
        var compClassnames = (i.className || itemRendererDefaultProps.className) + ' rct9k-items-inner';
        var outerClassnames = 'rct9k-items-outer item_draggable';
        var style = {};
        var isSelected = selectedItems.find(function (item) { return item == i.key; });
        if (isSelected !== undefined) {
            outerClassnames += ' rct9k-items-outer-selected';
        }
        return ((0, jsx_runtime_1.jsx)("span", { "data-testid": 'r9k1_' + timelineTestids.item + '_' + i.key, "data-item-index": i.key, className: outerClassnames, style: { left: left, width: width, top: top, backgroundColor: 'transparent', zIndex: zIndexFunction(i) }, children: (0, jsx_runtime_1.jsx)(Comp, __assign({}, itemRendererDefaultProps, i, { item: i, className: compClassnames, height: itemHeight })) }, i.key));
    });
}
exports.rowItemsRenderer = rowItemsRenderer;
/**
 * Render row layers
 * @param  {RowLayer[]} layers List of layers to render for this row
 * @param  {moment} vis_start The visible start of the timeline
 * @param  {moment} vis_end The visible end of the timeline
 * @param  {number} total_width pixel width of the timeline
 * @param  {number} itemHeight The layer height in px
 * @param  {function} getStartFromRowLayer Function that returns the start of a row layer
 * @param  {function} getEndFromRowLayer Function that returns the end of a row layer
 */
function rowLayerRenderer(layers, vis_start, vis_end, total_width, itemHeight, getStartFromRowLayer, getEndFromRowLayer) {
    var start_end_ms = vis_end.diff(vis_start, 'milliseconds');
    var pixels_per_ms = total_width / start_end_ms;
    var displayItems = lodash_1.default.map(lodash_1.default.sortBy(lodash_1.default.filter(layers, function (i) {
        return !getEndFromRowLayer(i).isBefore(vis_start) && !getStartFromRowLayer(i).isAfter(vis_end);
    }), function (i) { return getStartFromRowLayer(i).unix(); }), function (item) { return lodash_1.default.clone(item); });
    return lodash_1.default.map(displayItems, function (i) {
        var style = i.style, rowNumber = i.rowNumber;
        var item_offset_mins = getStartFromRowLayer(i).diff(vis_start, 'milliseconds');
        var item_duration_mins = getEndFromRowLayer(i).diff(getStartFromRowLayer(i), 'milliseconds');
        var left = Math.round(item_offset_mins * pixels_per_ms);
        var width = Math.round(item_duration_mins * pixels_per_ms);
        var height = itemHeight - (rowNumber === 0 ? 2 : 1); // for border
        var outerClassnames = 'rct9k-row-layer';
        return ((0, jsx_runtime_1.jsx)("div", { "data-item-index": i.key, className: outerClassnames, style: __assign(__assign({}, style), { left: left, width: width, height: height }) }, "r-".concat(rowNumber, "-").concat(getStartFromRowLayer(i).unix())));
    });
}
exports.rowLayerRenderer = rowLayerRenderer;
/**
 * Gets the row object for a given x and y pixel location
 * @param  {number} x The x coordinate of the pixel location
 * @param  {number} y The y coordinate of the pixel location
 * @param  {Object} topDiv Div to search under
 * @returns {Object} The row object at that coordinate
 */
function getNearestRowObject(x, y, topDiv) {
    if (topDiv === void 0) { topDiv = document; }
    var elementsAtPixel = document.elementsFromPoint(x, y);
    return lodash_1.default.find(elementsAtPixel, function (e) {
        var inDiv = topDiv.contains(e);
        return inDiv && e.hasAttribute('data-row-index');
    });
}
exports.getNearestRowObject = getNearestRowObject;
/**
 * Gets the row number for a given row object
 * @param  {Object} elem The row object
 * @returns {number} The row number
 */
function getRowObjectRowNumber(elem) {
    return Number(elem ? elem.getAttribute('data-row-index') : 0);
}
exports.getRowObjectRowNumber = getRowObjectRowNumber;
/**
 * Gets the vertical margins and borders given an object
 * @param  {Object} elem The row object
 * @returns {number} the pixel position of the bottom of the element
 */
function getVerticalMarginBorder(elem) {
    var computedStyles = window.getComputedStyle(elem);
    // top margin plus bottom margin halved
    var rowMargins = (Math.ceil(parseFloat(computedStyles['marginTop']) + parseFloat(computedStyles['marginBottom'])) || 1) / 2;
    // half the size of the border seems important
    var rowBorders = (Math.ceil(parseFloat(computedStyles['borderTopWidth']) + parseFloat(computedStyles['borderBottomWidth'])) || 1) /
        2;
    return Number(rowMargins + rowBorders);
}
exports.getVerticalMarginBorder = getVerticalMarginBorder;
/**
 * Gets the true bottom location given an object
 * @param  {Object} elem an element
 * @returns {number} the pixel position of the bottom of the element
 */
function getTrueBottom(elem) {
    /*
    @bendog: leaving this here as a helper, if there's ever a bug around inner items size
    // get object shape
    const rects = elem.getClientRects();
    const bottom = Math.max(Object.values(rects).map(o => o.bottom), 0);
     */
    // calculate the true bottom
    var bound = elem.getBoundingClientRect();
    var bottom = Math.floor(bound.top + bound.height);
    return Number(bottom);
}
exports.getTrueBottom = getTrueBottom;
/**
 * Gets the row number for a given x and y pixel location
 * @param  {number} x The x coordinate of the pixel location
 * @param  {number} y The y coordinate of the pixel location
 * @param  {Object} topDiv Div to search under
 * @returns {number} The row number
 */
function getNearestRowNumber(x, y, topDiv) {
    if (topDiv === void 0) { topDiv = document; }
    var elementsAtPixel = document.elementsFromPoint(x, y);
    var targetRow = lodash_1.default.find(elementsAtPixel, function (e) {
        var inDiv = topDiv.contains(e);
        return inDiv && e.hasAttribute('data-row-index');
    });
    return targetRow ? targetRow.getAttribute('data-row-index') : 0;
}
exports.getNearestRowNumber = getNearestRowNumber;
/**
 * Use to find the height of a row, given a set of items
 * @param  {Item[]} items List of items
 * @param  {function} getStartFromItem Function that returns the start of an item.
 * @param  {function} getEndFromItem Function that returns the end of an item.
 * @param  {boolean} useMoment This parameter is necessary because this method is also called when
 * the component receives new props.
 * @returns {number} Max row height
 */
function getMaxOverlappingItems(items, getStartFromItem, getEndFromItem, useMoment, displayItemOnSeparateRowIfOverlap, rowIndex) {
    if (displayItemOnSeparateRowIfOverlap == false) {
        return 1;
    }
    return positionItemsOnRowAndGetRowHeight(items, rowIndex, displayItemOnSeparateRowIfOverlap, getStartFromItem, getEndFromItem);
}
exports.getMaxOverlappingItems = getMaxOverlappingItems;
/**
 * It finds the ancestor with the provided className of the element.
 * @param {Object} element the DOM element
 * @param {string} className
 * @returns {Object} ancestor with className
 */
function findAncestorWithClassName(element, className) {
    while ((element = element.parentNode) && !element.classList.contains(className))
        ;
    return element;
}
exports.findAncestorWithClassName = findAncestorWithClassName;
/**
 * A special case is when we try to select items from a row that is scrolled (not fully visible).
 * The `top` position of that row is not visible, so when we move the mouse and try to find the nearest row object
 * using the `top` position, it will not find the actual row because at that position the row is not visible.
 * In this case we will use the `top` position of the viewport (the container of the rows).
 * @param {Object} row the DOM element of the row object
 * @param {number} top
 */
function adjustRowTopPositionToViewport(row, top) {
    var viewport = findAncestorWithClassName(row, 'ReactVirtualized__Grid').getBoundingClientRect();
    if (viewport.top > top) {
        return viewport.top;
    }
    return top;
}
exports.adjustRowTopPositionToViewport = adjustRowTopPositionToViewport;
// ***************************************************
//  Internal functions
// ***************************************************
function positionItemsOnRowAndGetRowHeight(items, rowIndex, displayItemOnSeparateRowIfOverlap, getStartFromItem, getEndFromItem, positionItemOnRow) {
    if (positionItemOnRow === void 0) { positionItemOnRow = function () { }; }
    var rowOffset = 0;
    // sorted in reverse order as we iterate over the array backwards
    var sorted_items = lodash_1.default.sortBy(items, function (i) { return -getStartFromItem(i).unix(); });
    while (sorted_items.length > 0) {
        var lastEnd = null;
        for (var i = sorted_items.length - 1; i >= 0; i--) {
            var displayCurrentItemOnSeparateRow = typeof displayItemOnSeparateRowIfOverlap === "function"
                ? displayItemOnSeparateRowIfOverlap(sorted_items[i], rowIndex)
                : displayItemOnSeparateRowIfOverlap;
            if (lastEnd === null || getStartFromItem(sorted_items[i]) >= lastEnd || !displayCurrentItemOnSeparateRow) {
                // Update the lastEnd only for the items that are explicitlly requesting to be on a different row in case of overlapping,
                // because the others act like they are invisible for overlapping (any other segments can overlap them without further checking)
                if (displayCurrentItemOnSeparateRow) {
                    lastEnd = getEndFromItem(sorted_items[i]);
                }
                positionItemOnRow(sorted_items[i], rowOffset);
                sorted_items.splice(i, 1);
            }
        }
        rowOffset++;
    }
    return Math.max(rowOffset, 1);
}
//# sourceMappingURL=itemUtils.js.map